import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatCardModule,
  MatButtonModule,
  MatInputModule,
  MatFormFieldModule,
  MatProgressSpinnerModule,
  MatDialogModule,
  MatMenuModule,
  MatAutocompleteModule,
  MatIconModule,
  MatTabsModule,
  MatSelectModule,
  MatTooltipModule,
  MatButtonToggleModule,
  MatToolbarModule,
  MatSidenavModule,
  MatExpansionModule,
  MatNativeDateModule,
  MatDatepickerModule,
  MatCheckboxModule,
  MatTableModule,
  MatProgressBarModule,
  MatPaginatorModule,
  MatSortModule,
  MatSnackBarModule,
  MatBottomSheetModule,
  MatSlideToggleModule,
  MatTreeModule,
  MatRadioModule,
  MatBadgeModule,
  MatChipsModule,
  MatStepperModule,
  MatGridListModule,
  MatSliderModule
} from '@angular/material';
import { BreadcrumbComponent } from '../site-view/breadcrumb/breadcrumb.component';
import { SelectCheckboxDirective } from './directives/select-checkbox.directive';
import { AlarmLevelPipe } from '../pipes/alarm-level.pipe';
import { AlarmSchemaPipe } from '../pipes/alarm-schema.pipe';
import { TrendMassagePipe } from '../pipes/trend-massage.pipe';
import { DragDropDirective } from './directives/drag-drop.directive';
import { AlarmObjTypePipe } from '../pipes/alarm-obj-type.pipe';
import { PortTypePipe } from '../pipes/port-type.pipe';
import { PortIconPipe } from '../pipes/port-icon.pipe';
import { AlarmTypePipe } from '../pipes/alarm-type.pipe';
import { SelectPortOrDeviceDirective } from './directives/select-port-or-device.directive';
import { ResizeDirective } from '../site-view/resize-dialog.directive';
import { DragDirective } from '../site-view/drag.directive';
import { EditProfileComponent } from '../edit-profile/edit-profile/edit-profile.component';
import { SearchComponent } from './search/search.component';
import { PortDeviceStatusDirective } from './directives/port-device-status.directive';
import { SiteIconComponent } from './icons/site-icon/site-icon.component';
import { PortIconComponent } from './icons/port-icon/port-icon.component';
import { DeviceIconComponent } from './icons/device-icon/device-icon.component';
import { ObjectTypePipe } from '../pipes/object-type.pipe';
import { StepPipe } from '../pipes/step-pipe.pipe';
import { NotitificationTypePipe } from '../pipes/notification-type.pipe';
import { ConfirmDeleteComponent } from './confirm-delete/confirm-delete.component';
import { HighestAlarmInGroupPipe, HighestAlarmInGroupPipeReturnAlarmLevel } from '../pipes/highest-alarm-in-group-pipe.pipe';
import { AlarmToStringPipe } from '../pipes/alarm-to-string-pipe.pipe';
import { AlarmMessagePipe } from '../pipes/alarm-message-pipe.pipe';

import {MatListModule} from '@angular/material/list';
import { TruncatePipe } from '../pipes/truncate.pipe';
import { EventTypePipe } from '../pipes/event-pipes/event-type.pipe';
import { EventStatusPipe } from '../pipes/event-pipes/event-status.pipe';
import { DeviceTypePipe } from '../pipes/device-type.pipe';
import { DeviceStatusPipe } from '../pipes/device-status.pipe';
import { EventObjectTypePipe } from '../pipes/event-pipes/event-object-type.pipe';
import { ChangePasswordComponent } from '../system-management/system-users/modals/change-password/change-password.component';
import { ButtonAccessDirective } from './directives/button-access.directive';
import { NotForViewOnlyDirective } from './directives/not-for-view-only.directive';
import { SizeDetectorDirective } from './directives/size-detector.directive';
import { LayoutPointDirective } from './directives/layout-point.directive';
import { IntToResPipe } from '../pipes/int-to-res.pipe';
import { AddSmButtonDirective } from '../system-management/user-groups/modals/edit-user-group/add-sm-button.directive';
import { SortAlphaOnPropPipe } from '../pipes/sort-alpha-on-prop.pipe';




const modules: any[] = [
  CommonModule,
  MatCardModule,
  MatButtonModule,
  MatInputModule,
  MatFormFieldModule,
  MatSelectModule,
  MatIconModule,
  MatTooltipModule,
  MatButtonToggleModule,
  MatDialogModule,
  MatProgressSpinnerModule,
  MatMenuModule,
  MatAutocompleteModule,
  MatTabsModule,
  FlexLayoutModule,
  MatToolbarModule,
  MatSidenavModule,
  MatExpansionModule,
  MatNativeDateModule,
  MatDatepickerModule,
  MatCheckboxModule,
  MatTableModule,
  MatProgressBarModule,
  MatBottomSheetModule,
  MatPaginatorModule,
  MatSortModule,
  MatSnackBarModule,
  MatSlideToggleModule,
  MatTreeModule,
  MatRadioModule,
  FormsModule,
  ReactiveFormsModule,
  MatBadgeModule,
  MatChipsModule,
  MatStepperModule,
  MatGridListModule,
  MatSliderModule

];

@NgModule({
  imports: modules,
  declarations: [

    EditProfileComponent,
    SearchComponent,
    ConfirmDeleteComponent, //move away from having mulptiple of these, just have one return yes or no and act on that

    //pipe
    AlarmLevelPipe,
    AlarmSchemaPipe,
    TrendMassagePipe,
    AlarmObjTypePipe,
    PortTypePipe,
    PortIconPipe,
    IntToResPipe,
    AlarmTypePipe,
    ObjectTypePipe,
    StepPipe,
    NotitificationTypePipe,
    HighestAlarmInGroupPipe,
    AlarmToStringPipe,
    HighestAlarmInGroupPipeReturnAlarmLevel,
    AlarmMessagePipe,
    TruncatePipe,
    EventStatusPipe,
    DeviceTypePipe,
    DeviceStatusPipe,
    EventTypePipe,
    EventObjectTypePipe,
    SortAlphaOnPropPipe,

    //directive
    DragDropDirective,
    SelectPortOrDeviceDirective,
    ResizeDirective,
    DragDirective,
    PortDeviceStatusDirective,
    SiteIconComponent,
    PortIconComponent,
    DeviceIconComponent,
    ChangePasswordComponent,
    ButtonAccessDirective,
    NotForViewOnlyDirective,
    SizeDetectorDirective,
    LayoutPointDirective,
    AddSmButtonDirective,
  

  ],
  entryComponents: [
    EditProfileComponent,
    SearchComponent,
    ConfirmDeleteComponent,
    ChangePasswordComponent
  ],
  exports:[
    MatListModule,
    modules,
        //pipe
        AlarmLevelPipe,
        AlarmSchemaPipe,
        TrendMassagePipe,
        AlarmObjTypePipe,
        PortTypePipe,
        PortIconPipe,
        IntToResPipe,
        AlarmTypePipe,
        ObjectTypePipe,
        StepPipe,
        NotitificationTypePipe,
        HighestAlarmInGroupPipe,
        AlarmToStringPipe,
        HighestAlarmInGroupPipeReturnAlarmLevel,
        AlarmMessagePipe,
        TruncatePipe,
        EventStatusPipe,
        DeviceTypePipe,
        DeviceStatusPipe,
        EventTypePipe,
        EventObjectTypePipe,
        SortAlphaOnPropPipe,
    
        //directive
        DragDropDirective,
        SelectPortOrDeviceDirective,
        ResizeDirective,
        DragDirective,
        PortDeviceStatusDirective,
        ButtonAccessDirective,
        ChangePasswordComponent,
        SizeDetectorDirective,
        LayoutPointDirective,
        AddSmButtonDirective,


        //icons components
        SiteIconComponent,
        PortIconComponent,
        DeviceIconComponent

  ],
  providers: [TrendMassagePipe, StepPipe] //try get this out of components and use strictly in templates
})
export class SharedModule { }